import Grid from 'app/KinerjaKSPage/components/EvaluationResult/components/Grid'
import {
  TextLabel,
  TextValue,
} from 'app/KinerjaKSPage/components/EvaluationResult/components/Texts'
import CardPeriodType from 'app/KinerjaShared/components/CardPeriodType'

import type { FC } from 'react'

type EvaluationResultInfoProps = {
  name: string
  customPeriod?: React.ReactNode
}

// Used to define the grid layout for the details section
const childrenLeftProps = { className: 'col-span-4' },
  childrenRightProps = { className: 'col-span-4' }

const EvaluationResultInfo: FC<EvaluationResultInfoProps> = ({
  name,
  customPeriod,
}) => {
  return (
    <>
      <Grid
        childrenLeftProps={childrenLeftProps}
        childrenRightProps={childrenRightProps}
        childrenLeft={
          <>
            <TextLabel>Nama Instansi</TextLabel>
            <TextValue className="text-gray-90 overflow-wrap-anywhere">
              {name}
            </TextValue>
          </>
        }
        childrenRight={
          <div>
            <TextLabel>Periode Penilaian</TextLabel>
            <TextValue className="text-gray-90">
              {!!customPeriod ? (
                customPeriod
              ) : (
                <CardPeriodType
                  withDate
                  withYear
                  separator=" sampai dengan "
                  type="all"
                />
              )}
            </TextValue>
          </div>
        }
      />
    </>
  )
}
export default EvaluationResultInfo
